export default __webpack_public_path__ + "static/media/love-biz.46caead5.png";